import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, inject, TemplateRef, OnDestroy, AfterViewInit } from '@angular/core';
import { studyModel } from 'src/models/study.model';
import { ParticipantService } from 'src/services/participant.service';
import { participantModel, participantExportExcel } from 'src/models/participant.model';
import { ExcelExportService } from 'src/app/service/excel-export.service';
import { MultiSelect } from 'primeng/multiselect';
import { applicantsFilter } from 'src/app/model/gridFilter.model';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { AppConfig } from 'src/app/app.config';
import { UserPreferencesStore } from 'src/app/store/user-preferences/user-preferences.store';
import { NavigationStore } from 'src/app/store/navigation/navigation.store';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { DynamicColumnConfig, DynamicTableConfig, DynamicTableFilter, ExportEvent } from 'src/app/shared/dynamic-table/dynamic-table.model';
import { DynamicTableComponent } from 'src/app/shared/dynamic-table/dynamic-table.component';
import { ConversionHelper } from 'src/Utilities/utility';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-admin-participant-list',
  templateUrl: './admin-participant-list.component.html',
  styleUrls: ['./admin-participant-list.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS, DynamicTableComponent]
})
export class AdminParticipantListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('scrollTop', { static: true }) scrollTop: ElementRef;
  @ViewChild('search', { static: true }) search: ElementRef;
  @ViewChildren('studyNameClear') clearStudy: QueryList<MultiSelect>;
  @ViewChildren('nameClear') clearName: QueryList<MultiSelect>;
  @ViewChildren('whentocallClear') clearwhentocall: QueryList<MultiSelect>;
  @ViewChildren('ageClear') clearage: QueryList<MultiSelect>;
  @ViewChildren('genderClear') cleargender: QueryList<MultiSelect>;
  @ViewChildren('statusClear') clearstatus: QueryList<MultiSelect>;
  @ViewChild(DynamicTableComponent) dynamicTable: DynamicTableComponent;

  // Custom cell templates
  @ViewChild('nameTemplate', { static: false }) nameTemplate: TemplateRef<any>;
  @ViewChild('dobTemplate', { static: false }) dobTemplate: TemplateRef<any>;
  @ViewChild('ageTemplate', { static: false }) ageTemplate: TemplateRef<any>;
  @ViewChild('statusTemplate', { static: false }) statusTemplate: TemplateRef<any>;

  dropdownList = [];
  sselecteditem: number = -1;
  availablestudies: studyModel;
  allparticipants: participantModel[] = [];
  participantlist: participantModel[] = [];
  allparticipantsFinalExport: participantExportExcel[] = [];
  participantObject: participantExportExcel = new participantExportExcel();
  filteredParticipantlist: participantModel[] = [];
  createdDateFlag: boolean;
  cols: any[];
  name: SelectItem[] = [];
  phone: SelectItem[] = [];
  whentocall: SelectItem[] = [];
  age: SelectItem[] = [];
  gender: SelectItem[] = [];
  studynumber: SelectItem[] = [];
  status: SelectItem[] = [];
  dob: SelectItem[] = [];
  applicantsFilter: applicantsFilter = new applicantsFilter();
  exportapplicantsFilter: applicantsFilter = new applicantsFilter();
  applicantFilterHier: string[] = [];
  selectedWhenToCall: string[] = [];
  checkedWhenToCall: string[] = [];
  selectedStudyNumber: string[] = [];
  checkedStudyNumber: string[] = [];
  selectedAge: number[] = [];
  checkedAge: number[] = [];
  selectedGender: string[] = [];
  checkedGender: string[] = [];
  selectedStatus: string[] = [];
  checkedStatus: string[] = [];
  selectedDob: string[] = [];
  checkedDob: string[] = [];
  isFromSessionStore = false;
  isFirstNavigation = false;
  isSearchFilterApplied = false;
  @ViewChild('dt') tableData: Table;
  searchFilterData: any[];
  sessionStore: any;
  isClearFilterOn = false;
  isDeleteEnabled = false;
  selectedApplicants: participantModel[] = [];
  datePipe = new DatePipe('en-US');
  isLoading: boolean = false;

  // Dynamic table configuration
  dynamicColumns: DynamicColumnConfig[] = [];
  tableConfig: DynamicTableConfig = {};
  cellTemplates: { [field: string]: TemplateRef<any> } = {};

  private readonly userPreferencesStore = inject(UserPreferencesStore);
  private readonly navigationStore = inject(NavigationStore);
  private readonly authStore = inject(AuthStore);

  IsDeleteVisible = false;
  IsExportVisible = false;
  private originalFilteredData: participantModel[] = [];
  participantListForExport: any[];

  constructor(private participantService: ParticipantService, 
    private exportExcel: ExcelExportService,
    private cdr: ChangeDetectorRef) {
    this.isFirstNavigation = this.navigationStore.isFirstNavigationToApplicants();
  }

  private deferUiUpdate(updateFn: () => void): void {
    Promise.resolve().then(() => {
      updateFn();
      this.cdr.markForCheck();
    });
  }
  userId: string;
  ngOnInit() {
    this.authStore.setIsAdminUser(true);
    // Initialize dynamic table configuration
    this.tableConfig = {
      rows: 50,
      selectable: true,
      selectionMode: 'multiple',
      globalSearch: true,
      exportable: true,
      deletable: true,
      lazy: false,
      dataKey: 'participantId',
      preferenceKey: 'applicants',
      supportFilterHierarchy: true,
      title: 'Applicants',
      columnFilteringEnabled: false,
      addable: false
    };

    this.cols = [
      { field: 'name', header: 'Applicant Name', width: '175px' },
      { field: 'dob', header: 'DOB', width: '130px' },
      { field: 'phone', header: 'Phone', width: '125px' },
      { field: 'WhentoCall', header: 'When to Call', width: '160px' },
      { field: 'age', header: 'Age', width: '105px' },
      { field: 'gender', header: 'Gender', width: '125px' },
      { field: 'studyName', header: 'Study Number', width: '175px' },
      { field: 'status', header: 'Status', width: '130px' },
      { field: 'adminId', header: 'Admin ID', width: '125px' }
    ];

    // Initialize dynamic columns configuration
    this.dynamicColumns = [
      { field: 'name', header: 'Applicant Name', width: '175px', sortable: true, customTemplate: 'nameTemplate', dataType: 'text' },
      { field: 'dob', header: 'DOB', width: '130px', sortable: true, sortField: 'originalDob', customTemplate: 'dobTemplate', dataType: 'date' },
      { field: 'phone', header: 'Phone', width: '125px', sortable: true, dataType: 'text' },
      {
        field: 'WhentoCall',
        header: 'When to Call',
        width: '160px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'WhentoCall',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'age',
        header: 'Age',
        width: '105px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'age',
        filterOptions: [],
        customTemplate: 'ageTemplate',
        dataType: 'number'
      },
      {
        field: 'gender',
        header: 'Gender',
        width: '125px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'gender',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'studyName',
        header: 'Study Number',
        width: '175px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'studyName',
        filterOptions: [],
        dataType: 'text'
      },
      {
        field: 'status',
        header: 'Status',
        width: '130px',
        sortable: true,
        filterable: true,
        filterType: 'multiselect',
        filterField: 'status',
        filterOptions: [],
        customTemplate: 'statusTemplate',
        dataType: 'text'
      },
      { field: 'adminId', header: 'Admin ID', width: '125px', sortable: true, dataType: 'text' }
    ];

    // Check if filters should be restored from store (tab switch scenario)
    // On page refresh, the store will be empty so filters will be cleared automatically
    const storedFilter = this.userPreferencesStore.applicants();
    const hasActiveFilters = storedFilter && (
      (storedFilter.studyNumber?.length > 0) ||
      (storedFilter.age?.length > 0) ||
      (storedFilter.gender?.length > 0) ||
      (storedFilter.whentocall?.length > 0) ||
      (storedFilter.status?.length > 0) ||
      (storedFilter.dob?.length > 0) ||
      (storedFilter.searchTerm && storedFilter.searchTerm.length > 0) ||
      (storedFilter.filterHierarchy && storedFilter.filterHierarchy.length > 0)
    );

    // Restore filters only if navigating back to this tab (not a fresh page load)
    if (hasActiveFilters && !this.isFirstNavigation) {
      this.applicantsFilter = storedFilter;
      this.isFromSessionStore = true;
      this.selectedStudyNumber = this.applicantsFilter.studyNumber || [];
      this.selectedAge = this.applicantsFilter.age || [];
      this.selectedGender = this.applicantsFilter.gender || [];
      this.selectedWhenToCall = this.applicantsFilter.whentocall || [];
      this.selectedStatus = this.applicantsFilter.status || [];
      this.selectedDob = this.applicantsFilter.dob || [];
      // Restore filter hierarchy
      this.applicantFilterHier = this.applicantsFilter.filterHierarchy || [];
    } else {
      // Fresh page load or first navigation - clear any stored filters
      this.userPreferencesStore.resetApplicantsFilter();
      this.applicantsFilter = new applicantsFilter();
      this.isFromSessionStore = false;
    }

    this.getApplicants();
  }

  ngAfterViewInit() {
    // Wire up custom cell templates
    if (this.nameTemplate) {
      this.cellTemplates['nameTemplate'] = this.nameTemplate;
    }
    if (this.dobTemplate) {
      this.cellTemplates['dobTemplate'] = this.dobTemplate;
    }
    if (this.ageTemplate) {
      this.cellTemplates['ageTemplate'] = this.ageTemplate;
    }
    if (this.statusTemplate) {
      this.cellTemplates['statusTemplate'] = this.statusTemplate;
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    // Mark that this is no longer the first navigation
    // This ensures filters will be restored on next visit (tab switch)
    // On page refresh, NavigationStore resets so it will be first navigation again
    this.navigationStore.setFirstNavigationToApplicants(false);
  }

  getAllParticipants() {
    this.getFilters("", "");
    this.participantService.getAllParticipants(this.applicantsFilter)
      .subscribe(_allparticipant => {
        this.allparticipants = _allparticipant;
        this.participantlist = _allparticipant;

        for (let key in this.participantlist) {
          if (this.participantlist.hasOwnProperty(key)) {
            this.participantlist[key].name = this.participantlist[key].lastName + ", " + this.participantlist[key].firstName;
            this.participantlist[key].originalDob = this.participantlist[key].dob;
            this.participantlist[key].dobDisplay = this.datePipe.transform(this.participantlist[key].dob, 'MM/dd/yyyy');
            /* this.participantlist[key].dob = this.participantlist[key].originalDob;*/
            this.participantlist[key].gender = this.participantlist[key].gender === "M" ? "Male" : "Female";
            this.participantlist[key].WhentoCall = this.participantlist[key].WhentoCall === null ? "" : this.participantlist[key].WhentoCall;
            this.participantlist[key].age = this.participantlist[key].age === null ? 0 : this.participantlist[key].age;
            this.participantlist[key].status = this.participantlist[key].status === null ? "" : this.participantlist[key].status;
          }
        }
      });
  }

  getApplicants() {
    if (this.applicantsFilter.age && this.applicantsFilter.age.includes(0) && !this.applicantsFilter.age.includes(null))
      this.applicantsFilter.age.push(null);

    this.isLoading = true;
    this.participantService.getAllParticipants(this.applicantsFilter)
      .subscribe(response => {
        const normalizedParticipants = (response || []).map(item => {
          item.name = item.lastName + ", " + item.firstName;
          item.originalDob = item.dob;
          item.dobDisplay = this.datePipe.transform(item.dob, 'MM/dd/yyyy');
          item.gender = item.gender === "M" ? "Male" : "Female";
          item.WhentoCall = item.WhentoCall === null ? "" : item.WhentoCall;
          item.age = item.age === null ? 0 : item.age;
          item.status = item.status === null ? "" : item.status;
          return item;
        });

        this.participantlist = normalizedParticipants;
        this.filteredParticipantlist = normalizedParticipants;
        this.originalFilteredData = [];

        if (this.isFromSessionStore && this.dynamicTable) {
          this.dynamicTable['filterHierarchy'] = [...this.applicantFilterHier];
          const storedFilter = this.userPreferencesStore.applicants();
          if (storedFilter) {
            this.dynamicTable.selectedFilters['studyName'] = [...(storedFilter.studyNumber || [])];
            this.dynamicTable.selectedFilters['WhentoCall'] = [...(storedFilter.whentocall || [])];
            this.dynamicTable.selectedFilters['age'] = [...(storedFilter.age || [])];
            this.dynamicTable.selectedFilters['gender'] = [...(storedFilter.gender || [])];
            this.dynamicTable.selectedFilters['status'] = [...(storedFilter.status || [])];
            this.dynamicTable.selectedFilters['dob'] = [...(storedFilter.dob || [])];
          }
        }

        this.getFilters("", "");
        this.isLoading = false;

        setTimeout(() => {
          if (this.dynamicTable) {
            if (this.isFromSessionStore) {
              this.restoreDynamicTableFilters();
              this.isFromSessionStore = false;
            } else {
              this.dynamicTable.initializeFiltersWithAllSelected(this.isFirstNavigation);
            }
          }
          this.cdr.detectChanges();
        }, 0);
      });
  }

  onCustomSearch(event: any, dt: Table) {
    let searchValue = event.target.value;
    this.isSearchFilterApplied = searchValue === '' ? false : true;

    if (!searchValue || searchValue.trim() === '') {
      if (this.originalFilteredData.length > 0) {
        this.filteredParticipantlist = [...this.originalFilteredData];
        dt.value = [...this.originalFilteredData];
        this.originalFilteredData = [];
      }
      return;
    }

    if (this.originalFilteredData.length === 0) {
      this.originalFilteredData = [...this.filteredParticipantlist];
    }

    let searchTerm = searchValue.toLowerCase().trim();

    let filtered = this.originalFilteredData.filter(item => {
      let matchesOtherFields =
        (item.lastName + ", " + item.firstName).toLowerCase().includes(searchTerm) ||
        (item.phone || '').toLowerCase().includes(searchTerm) ||
        (item.WhentoCall || '').toLowerCase().includes(searchTerm) ||
        (item.age !== null && item.age !== undefined ? item.age.toString() : '0').includes(searchTerm) ||
        (item.gender === "M" ? "Male" : "Female").toLowerCase().includes(searchTerm) ||
        (item.studyName || '').toLowerCase().includes(searchTerm) ||
        (item.status || '').toLowerCase().includes(searchTerm) ||
        (item.adminId || '').toLowerCase().includes(searchTerm);

      let dobDisplay = this.datePipe.transform(item.originalDob, 'MM/dd/yyyy') || '';
      let matchesDOB = dobDisplay.toLowerCase().includes(searchTerm);

      return matchesOtherFields || matchesDOB;
    });

    this.filteredParticipantlist = filtered;
    dt.value = filtered;
  }

  exportAsXLSX(): void {
    this.participantListForExport = [];
    this.participantService.getAllParticipants(this.exportapplicantsFilter).subscribe(
      (response: any[]) => {
        if (response?.length) {
          response.forEach(par => {
            let consentParts = [];
            if (par.allowPhone) consentParts.push('Phone');
            if (par.allowEmail) consentParts.push('Email');
            if (par.allowMessage) consentParts.push('SMS');

            let dobFormatted = par.dob
              ? this.datePipe.transform(par.dob, 'MM/dd/yyyy')
              : '';

            let heightInches = '';
            if (par.height !== undefined && par.height !== null && par.height !== '') {
              let heightStr = par.height.toString();
              let [feet, inches] = heightStr.split('.');
              let feetNum = Number.parseInt(feet, 10) || 0;
              let inchesNum = Number.parseInt(inches, 10) || 0;
              heightInches = (feetNum * 12 + inchesNum).toString();
            }

            let createdDateFormatted = '';
            if (par.createdDate) {
              let dateObj = new Date(par.createdDate);
              let day = ('0' + dateObj.getDate()).slice(-2);
              let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
              let month = monthNames[dateObj.getMonth()];
              let year = dateObj.getFullYear();
              let hours = ('0' + dateObj.getHours()).slice(-2);
              let minutes = ('0' + dateObj.getMinutes()).slice(-2);
              createdDateFormatted = `${day}-${month}-${year}_${hours}:${minutes}`;
            }

            let participantDetail: any = {
              'Study Number': par.studyName,
              'First Name': par.firstName,
              'Last Name': par.lastName,
              'Email Id': par.emailId,
              'Phone': par.phone,
              'When to Call': par.WhentoCall,
              'Consent to Contact': consentParts.join(',') || '',
              'DOB': dobFormatted,
              'Gender': par.gender === 'M' ? 'Male' : 'Female',
              'Height (Total Inches)': ConversionHelper.feetToInches(par.height),
              'Weight': par.weight,
              'BMI': par.bmi,
              'Race': par.race,
              'Attempt Date/Time': createdDateFormatted,
              'Status': par.status,
              'Admin ID': par.adminId || ''
            };

            this.participantListForExport.push(participantDetail);
          });

          setTimeout(() => {
            this.exportExcel.exportAsExcelFile(this.participantListForExport, 'applicants-list');
          }, 1000);
        } else {
          alert('No participants found.');
        }
      },
      error => console.error('Error fetching participants', error)
    );
  }

  exportByFilterAsXLSX(): void {
    this.participantListForExport = [];

    let exportList = [];
    if (this.isSearchFilterApplied) {
      this.isSearchFilterApplied = false;
      exportList = this.tableData.filteredValue || [];
    } else {
      exportList = this.filteredParticipantlist || [];
    }

    if (exportList.length) {
      exportList.forEach(par => {
        let consentParts = [];
        if (par.allowPhone) consentParts.push('Phone');
        if (par.allowEmail) consentParts.push('Email');
        if (par.allowMessage) consentParts.push('SMS');
        let createdDateFormatted = '';
        if (par.createdDate) {
          let dateObj = new Date(par.createdDate);
          let day = ('0' + dateObj.getDate()).slice(-2);
          let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
          let month = monthNames[dateObj.getMonth()];
          let year = dateObj.getFullYear();
          let hours = ('0' + dateObj.getHours()).slice(-2);
          let minutes = ('0' + dateObj.getMinutes()).slice(-2);
          createdDateFormatted = `${day}-${month}-${year}_${hours}:${minutes}`;
        }
        let participantDetail: any = {
          'Study Number': par.studyName,
          'First Name': par.firstName,
          'Last Name': par.lastName,
          'Email Id': par.emailId,
          'Phone': par.phone,
          'When to Call': par.WhentoCall,
          'Consent to Contact': consentParts.join(',') || '',
          'DOB': par.dobDisplay,
          'Gender': par.gender === 'M' ? 'Male' : 'Female',
          'Height (Total Inches)': ConversionHelper.feetToInches(par.height),
          'Weight': par.weight,
          'BMI': par.bmi,
          'Race': par.race,
          'Attempt Date/Time': createdDateFormatted,
          'Status': par.status,
          'Admin ID': par.adminId || ''
        };

        this.participantListForExport.push(participantDetail);
      });

      setTimeout(() => {
        this.exportExcel.exportAsExcelFile(this.participantListForExport, 'applicants-list');
      }, 1000);
    } else {
      alert('No participants found.');
    }
  }


  getFilters(colname, clickType) {
    let applicantsFilterPrimary = new applicantsFilter();
    if (this.isFromSessionStore) {
      if (this.applicantFilterHier[0] === "studyName" && (colname !== "studyName" || clickType === "clear")) {
        this.studynumber = [];
        this.participantService.getApplicantsStudynumberFilter(applicantsFilterPrimary)
          .subscribe(response => {
            this.studynumber = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.studynumber.push({ label: response[key].studyName, value: response[key].studyName })
              }
            }
            this.updateDynamicColumnFilterOptions('studyName', this.studynumber);
          });
      }
      else if (this.applicantFilterHier[0] === "dob" && (colname !== "dob" || clickType === "clear")) {
        this.dob = [];
        this.participantService.getapplicantsDobFilter(applicantsFilterPrimary)
          .subscribe(response => {
            this.dob = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.dob.push({ label: response[key].dob ? this.datePipe.transform(response[key].dob, 'MM/dd/yyyy') : '(Blank)', value: response[key].dob });
              }
            }
            this.updateDynamicColumnFilterOptions('dob', this.dob);
          });
      }
      else if (this.applicantFilterHier[0] === "whentocall" && (colname !== "whentocall" || clickType === "clear")) {
        this.whentocall = [];
        this.participantService.getApplicantsWhentoCallFilter(applicantsFilterPrimary)
          .subscribe(response => {
            this.whentocall = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.whentocall.push({ label: response[key].WhentoCall === null || response[key].WhentoCall === "" ? "(Blank)" : response[key].WhentoCall, value: response[key].WhentoCall })
              }
            }
            this.updateDynamicColumnFilterOptions('WhentoCall', this.whentocall);
          });
      }
      else if (this.applicantFilterHier[0] === "age" && (colname !== "age" || clickType === "clear")) {
        this.age = [];
        this.participantService.getApplicantsAgeFilter(applicantsFilterPrimary)
          .subscribe(response => {
            this.age = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].age !== null)
                  this.age.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age })
              }
            }
            this.age = Array.from(this.age.reduce((m, t) => m.set(t.label, t), new Map()).values());
            this.updateDynamicColumnFilterOptions('age', this.age);
          });
      }
      else if (this.applicantFilterHier[0] === "gender" && (colname !== "gender" || clickType === "clear")) {
        this.gender = [];
        this.gender = [
          { label: 'Female', value: 'F' },
          { label: 'Male', value: 'M' }
        ];
        this.updateDynamicColumnFilterOptions('gender', this.gender);
      }
      else if (this.applicantFilterHier[0] === "status" && (colname !== "status" || clickType === "clear")) {
        this.status = [];
        this.participantService.getApplicantsStatusFilter(applicantsFilterPrimary)
          .subscribe(response => {
            this.status = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.status.push({ label: response[key].status, value: response[key].status })
              }
            }
            this.updateDynamicColumnFilterOptions('status', this.status);
          });
      }

      if (this.applicantsFilter.age && this.applicantsFilter.age.includes(0) && !this.applicantsFilter.age.includes(null))
        this.applicantsFilter.age.push(null);

      if (this.applicantFilterHier[0] !== "dob" && (colname !== "dob" || clickType === "clear")) {
        this.participantService.getapplicantsDobFilter(this.applicantsFilter)
          .subscribe(response => {
            this.dob = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.dob.push({ label: response[key].dob ? this.datePipe.transform(response[key].dob, 'MM/dd/yyyy') : '(Blank)', value: response[key].dob });
              }
            }
            this.updateDynamicColumnFilterOptions('dob', this.dob);
          });
      }
      if (this.applicantFilterHier[0] !== "whentocall" && (colname !== "whentocall" || clickType === "clear")) {
        this.participantService.getApplicantsWhentoCallFilter(this.applicantsFilter)
          .subscribe(response => {
            this.whentocall = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.whentocall.push({ label: response[key].WhentoCall === null || response[key].WhentoCall === "" ? "(Blank)" : response[key].WhentoCall, value: response[key].WhentoCall })
              }
            }
            this.updateDynamicColumnFilterOptions('WhentoCall', this.whentocall);
          });
      }
      if (this.applicantFilterHier[0] !== "age" && (colname !== "age" || clickType === "clear")) {
        this.participantService.getApplicantsAgeFilter(this.applicantsFilter)
          .subscribe(response => {
            this.age = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                if (response[key].age !== null)
                  this.age.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age })
              }
            }
            this.age = Array.from(this.age.reduce((m, t) => m.set(t.label, t), new Map()).values());
            this.updateDynamicColumnFilterOptions('age', this.age);
          });
      }
      if (this.applicantFilterHier[0] !== "gender" && (colname !== "gender" || clickType === "clear")) {
        this.gender = [];
        this.gender = [
          { label: 'Female', value: 'F' },
          { label: 'Male', value: 'M' }
        ];
        this.updateDynamicColumnFilterOptions('gender', this.gender);
      }
      if (this.applicantFilterHier[0] !== "studyName" && (colname !== "studyName" || clickType === "clear")) {
        this.participantService.getApplicantsStudynumberFilter(this.applicantsFilter)
          .subscribe(response => {
            this.studynumber = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.studynumber.push({ label: response[key].studyName, value: response[key].studyName })
              }
            }
            this.updateDynamicColumnFilterOptions('studyName', this.studynumber);
          });
      }
      if (this.applicantFilterHier[0] !== "status" && (colname !== "status" || clickType === "clear")) {
        this.participantService.getApplicantsStatusFilter(this.applicantsFilter)
          .subscribe(response => {
            this.status = [];
            for (let key in response) {
              if (response.hasOwnProperty(key)) {
                this.status.push({ label: response[key].status === null ? '(Blank)' : response[key].status, value: response[key].status })
              }
            }
            this.updateDynamicColumnFilterOptions('status', this.status);
          });
      }
    }
    else {
      // Only reset the filter if we're not restoring from session store
      if (!this.isFromSessionStore) {
        this.applicantsFilter = new applicantsFilter();
      }

      this.gender = [
        { label: 'Female', value: 'F' },
        { label: 'Male', value: 'M' }
      ];
      this.updateDynamicColumnFilterOptions('gender', this.gender);

      this.participantService.getApplicantsWhentoCallFilter(this.applicantsFilter)
        .subscribe(response => {
          this.whentocall = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              this.whentocall.push({ label: response[key].WhentoCall === null || response[key].WhentoCall === "" ? "(Blank)" : response[key].WhentoCall, value: response[key].WhentoCall })
            }
          }
          this.updateDynamicColumnFilterOptions('WhentoCall', this.whentocall);
        });
      this.participantService.getapplicantsDobFilter(this.applicantsFilter)
        .subscribe(response => {
          this.dob = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              this.dob.push({ label: response[key].dob ? this.datePipe.transform(response[key].dob, 'MM/dd/yyyy') : '(Blank)', value: response[key].dob });
            }
          }
          this.updateDynamicColumnFilterOptions('dob', this.dob);
        });
      this.participantService.getApplicantsAgeFilter(this.applicantsFilter)
        .subscribe(response => {
          this.age = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              if (response[key].age != null)
                this.age.push({ label: response[key].age === -2 ? '0' : response[key].age.toString(), value: response[key].age })
            }
          }
          this.age = Array.from(this.age.reduce((m, t) => m.set(t.label, t), new Map()).values());
          this.updateDynamicColumnFilterOptions('age', this.age);
        });
      this.participantService.getApplicantsStudynumberFilter(this.applicantsFilter)
        .subscribe(response => {
          this.studynumber = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              this.studynumber.push({ label: response[key].studyName, value: response[key].studyName })
            }
          }
          this.updateDynamicColumnFilterOptions('studyName', this.studynumber);
        });
      this.participantService.getApplicantsStatusFilter(this.applicantsFilter)
        .subscribe(response => {
          this.status = [];
          for (let key in response) {
            if (response.hasOwnProperty(key)) {
              this.status.push({ label: response[key].status === null ? '(Blank)' : response[key].status, value: response[key].status })
            }
          }
          this.updateDynamicColumnFilterOptions('status', this.status);
        });

    }

    this.filterApplicants(colname);
  }

  /* Clear Study Column */
  clearGridColumn(event, table, colname) {
    this.isClearFilterOn = true;
    switch (colname) {
      case "studyName":
        this.checkedStudyNumber = [];
        this.applicantsFilter.studyNumber = [];
        break;
      case "dob":
        this.checkedDob = [];
        this.applicantsFilter.dob = [];
        break;
      case "whentocall":
        this.checkedWhenToCall = [];
        this.applicantsFilter.whentocall = [];
        break;
      case "age":
        this.checkedAge = [];
        this.applicantsFilter.age = [];
        break;
      case "gender":
        this.checkedGender = [];
        this.applicantsFilter.gender = [];
        break;
      case "status":
        this.checkedStatus = [];
        this.applicantsFilter.status = [];
        break;
    }
    this.applicantFilterHier = this.applicantFilterHier.filter(x => x !== colname);
    this.clearPrescreenFilter(colname);
    table.filter('', colname, 'contains');
    this.userPreferencesStore.setApplicantsFilter(this.applicantsFilter);
  }

  filterGridRecords(event, table, colname) {
    this.isFromSessionStore = false;
    if (!this.applicantFilterHier.includes(colname))
      this.applicantFilterHier.push(colname);

    switch (colname) {
      case "whentocall":
        this.clearwhentocall.forEach(ds => {
          if (ds.value !== null) {
            this.applicantsFilter.whentocall = ds.value;
          }
         this.applicantsFilter.whentocall = this.applicantsFilter.whentocall.concat(this.selectedWhenToCall);
          ds.overlayVisible = false;
        });
        break;
      case "studyName":
        this.clearStudy.forEach(ds => {
          if (ds.value !== null) {
            this.applicantsFilter.studyNumber = ds.value;
          }
          this.applicantsFilter.studyNumber = this.applicantsFilter.studyNumber.concat(this.selectedStudyNumber);
          ds.overlayVisible = false;
        });
        break;
      case "age":
        this.clearage.forEach(ds => {
          if (ds.value !== null) {
            this.applicantsFilter.age = ds.value;
          }
          this.applicantsFilter.age = this.applicantsFilter.age.concat(this.selectedAge);
          ds.overlayVisible = false;
        });
        break;
      case "gender":
        this.cleargender.forEach(ds => {
          if (ds.value !== null) {
            this.applicantsFilter.gender = ds.value;
          }
          this.applicantsFilter.gender = this.applicantsFilter.gender.concat(this.selectedGender);
          ds.overlayVisible = false;
        });
        break;
      case "status":
        this.clearstatus.forEach(ds => {
          if (ds.value !== null) {
            this.applicantsFilter.status = ds.value;
          }
          this.applicantsFilter.status = this.applicantsFilter.status.concat(this.selectedStatus);
          ds.overlayVisible = false;
        });
        break;
    }

    if (this.applicantsFilter.age && this.applicantsFilter.age.includes(0) && !this.applicantsFilter.age.includes(null))
      this.applicantsFilter.age.push(null);

    this.participantService.getAllParticipants(this.applicantsFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;
        this.originalFilteredData = [];

        for (let key in this.filteredParticipantlist) {
          if (this.filteredParticipantlist.hasOwnProperty(key)) {
            this.filteredParticipantlist[key].name = this.filteredParticipantlist[key].lastName + ", " + this.filteredParticipantlist[key].firstName;
            this.filteredParticipantlist[key].originalDob = this.filteredParticipantlist[key].dob;
            this.filteredParticipantlist[key].dobDisplay = this.datePipe.transform(this.filteredParticipantlist[key].dob, 'MM/dd/yyyy');
            this.filteredParticipantlist[key].gender = this.filteredParticipantlist[key].gender === "M" ? "Male" : "Female";
            this.filteredParticipantlist[key].WhentoCall = this.filteredParticipantlist[key].WhentoCall === null ? "" : this.filteredParticipantlist[key].WhentoCall;
            this.filteredParticipantlist[key].age = this.filteredParticipantlist[key].age === null ? 0 : this.filteredParticipantlist[key].age;
            this.filteredParticipantlist[key].status = this.filteredParticipantlist[key].status === null ? "" : this.filteredParticipantlist[key].status;
          }
        }
        this.getFilters(colname, "ok");
      });
    this.userPreferencesStore.setApplicantsFilter(this.applicantsFilter);
  }

  clearPrescreenFilter(colname) {
    if (this.applicantsFilter.age && this.applicantsFilter.age.includes(0) && !this.applicantsFilter.age.includes(null))
      this.applicantsFilter.age.push(null);

    this.participantService.getAllParticipants(this.applicantsFilter)
      .subscribe(response => {
        this.participantlist = response;
        this.filteredParticipantlist = response;
        this.originalFilteredData = [];

        for (let key in this.filteredParticipantlist) {
          if (this.filteredParticipantlist.hasOwnProperty(key)) {
            this.filteredParticipantlist[key].name = this.filteredParticipantlist[key].lastName + ", " + this.filteredParticipantlist[key].firstName;
            this.filteredParticipantlist[key].originalDob = this.filteredParticipantlist[key].dob;
            this.filteredParticipantlist[key].dobDisplay = this.datePipe.transform(this.filteredParticipantlist[key].dob, 'MM/dd/yyyy');
            this.filteredParticipantlist[key].gender = this.filteredParticipantlist[key].gender === "M" ? "Male" : "Female";
            this.filteredParticipantlist[key].WhentoCall = this.filteredParticipantlist[key].WhentoCall === null ? "" : this.filteredParticipantlist[key].WhentoCall;
            this.filteredParticipantlist[key].age = this.filteredParticipantlist[key].age === null ? 0 : this.filteredParticipantlist[key].age;
            this.filteredParticipantlist[key].status = this.filteredParticipantlist[key].status === null ? "" : this.filteredParticipantlist[key].status;
          }
        }
        this.getFilters(colname, "clear");
      });
  }

  filterApplicants(filterFor) {
    for (let key in this.filteredParticipantlist) {
      if (this.filteredParticipantlist.hasOwnProperty(key)) {
        this.filteredParticipantlist[key].name = this.filteredParticipantlist[key].lastName + ", " + this.filteredParticipantlist[key].firstName;
        this.filteredParticipantlist[key].gender = this.filteredParticipantlist[key].gender === "M" ? "Male" : this.filteredParticipantlist[key].gender === "F" ? "Female" : this.filteredParticipantlist[key].gender;
        this.filteredParticipantlist[key].age = this.filteredParticipantlist[key].age === null ? -2 : this.filteredParticipantlist[key].age;
        this.filteredParticipantlist[key].createdDate = this.filteredParticipantlist[key].createdDate === null ? "" : this.filteredParticipantlist[key].createdDate;
      }
    }

    if (!this.isClearFilterOn) {
      if (this.isFromSessionStore) {
        this.checkedStudyNumber = this.selectedStudyNumber;
        this.checkedWhenToCall = this.selectedWhenToCall;
        this.checkedAge = this.selectedAge;
        this.checkedGender = this.selectedGender;
        this.checkedStatus = this.selectedStatus;
        this.checkedDob = this.selectedDob;
      } else {
        if (this.isFirstNavigation || this.sessionStore === null) {
          this.checkedStudyNumber = this.filteredParticipantlist.map(x => x.studyName)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.checkedWhenToCall = this.filteredParticipantlist.map(x => x.WhentoCall)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.checkedAge = this.filteredParticipantlist.map(x => x.age)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.checkedGender = this.gender.map(x => x.value);
          this.checkedStatus = this.filteredParticipantlist.map(x => x.status)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.checkedDob = this.filteredParticipantlist.map(x => x.dob)
            .filter((value, index, self) => self.indexOf(value) === index);
        } else {
          this.checkedStudyNumber = this.applicantsFilter.studyNumber;
          this.checkedWhenToCall = this.applicantsFilter.whentocall;
          this.checkedAge = this.applicantsFilter.age;
          this.checkedGender = this.applicantsFilter.gender;
          this.checkedStatus = this.applicantsFilter.status;
          this.checkedDob = this.applicantsFilter.dob;
        }
      }
    }
    this.isClearFilterOn = false;
    this.isFirstNavigation = false;
  }

  paginate(event) {
    this.scrollTop.nativeElement.focus();
  }

  checkAllPropertiesEmpty(): boolean {
    if (this.isSearchFilterApplied) {
      return false;
    }
    let properties = Object.values(this.applicantsFilter);
    return properties.every(property => Array.isArray(property) && property.length === 0);
  }

  onRowSelect() {
    this.updateDeleteButtonState();
  }

  onRowUnselect() {
    this.updateDeleteButtonState();
  }

  onHeaderCheckboxToggle() {
    this.updateDeleteButtonState();
  }

  updateDeleteButtonState() {
    this.isDeleteEnabled = this.selectedApplicants && this.selectedApplicants.length > 0;
  }

  getParticipantAnswersUrl(pid: number, sid: number): string {
    return `${AppConfig.appsettings.navigatorRoot}admin#/adminhome/admin-participant-answers/${pid}/${sid}`;
  }

  // ========== Dynamic Table Event Handlers ==========

  /**
   * Handle filter change from dynamic table
   * Saves filter state to UserPreferencesStore for persistence during tab switches
   * Filter state is cleared on page refresh (store is in-memory)
   */
  onDynamicFilterChange(filterState: DynamicTableFilter): void {
    // Reset session restore flag since this is a new filter action
    this.isFromSessionStore = false;

    // Map dynamic table filters to applicantsFilter model
    this.applicantsFilter.studyNumber = filterState.columnFilters['studyName'] || [];
    this.applicantsFilter.age = filterState.columnFilters['age'] || [];
    this.applicantsFilter.gender = filterState.columnFilters['gender'] || [];
    this.applicantsFilter.whentocall = filterState.columnFilters['WhentoCall'] || [];
    this.applicantsFilter.status = filterState.columnFilters['status'] || [];
    this.applicantsFilter.dob = filterState.columnFilters['dob'] || [];

    // Update filter hierarchy (both component and model)
    this.applicantFilterHier = filterState.filterHierarchy || [];
    this.applicantsFilter.filterHierarchy = this.applicantFilterHier;

    // Update search term
    if (filterState.searchTerm !== undefined) {
      this.isSearchFilterApplied = filterState.searchTerm.length > 0;
      this.applicantsFilter.searchTerm = filterState.searchTerm;
    } else {
      this.applicantsFilter.searchTerm = '';
      this.isSearchFilterApplied = false;
    }

    // Update pagination and sorting
    this.applicantsFilter.page = filterState.page || 0;
    this.applicantsFilter.rows = filterState.rows || 50;
    this.applicantsFilter.sortField = filterState.sortField || '';
    this.applicantsFilter.sortOrder = filterState.sortOrder || 1;

    // Update column settings
    this.applicantsFilter.columnSortingEnabled = filterState.columnSortingEnabled || {};
    this.applicantsFilter.columnFilteringEnabled = filterState.columnFilteringEnabled || {};

    // Handle age 0 -> null conversion
    if (this.applicantsFilter.age && this.applicantsFilter.age.includes(0) && !this.applicantsFilter.age.includes(null)) {
      this.applicantsFilter.age.push(null);
    }

    // Fetch filtered data from server
    this.participantService.getAllParticipants(this.applicantsFilter)
      .subscribe(response => {
        const normalizedParticipants = (response || []).map(item => {
          item.name = item.lastName + ", " + item.firstName;
          item.originalDob = item.dob;
          item.dobDisplay = this.datePipe.transform(item.dob, 'MM/dd/yyyy');
          item.gender = item.gender === "M" ? "Male" : "Female";
          item.WhentoCall = item.WhentoCall === null ? "" : item.WhentoCall;
          item.age = item.age === null ? 0 : item.age;
          item.status = item.status === null ? "" : item.status;
          return item;
        });

        let filteredParticipants = normalizedParticipants;
        if (this.applicantsFilter.searchTerm) {
          const searchTerm = this.applicantsFilter.searchTerm.trim().toLowerCase();
          filteredParticipants = normalizedParticipants.filter(participant => {
            const fields = [
              participant.name,
              participant.firstName,
              participant.lastName,
              participant.phone,
              participant.WhentoCall,
              (participant.age > 0 ? participant.age.toString() : ''),
              participant.gender,
              participant.studyName,
              participant.status,
              participant.adminId,
              participant.dobDisplay
            ];
            return fields.some(field => (field || '').toString().toLowerCase().includes(searchTerm));
          });
        }

        this.deferUiUpdate(() => {
          this.participantlist = normalizedParticipants;
          this.filteredParticipantlist = filteredParticipants;
          this.originalFilteredData = [];
          this.userPreferencesStore.setApplicantsFilter(this.applicantsFilter);
        });
      });
  }

  /**
   * Handle filter options refresh request from dynamic table
   */
  onFilterOptionsRefresh(event: { field: string; currentFilters: any; hierarchy: string[] }): void {
    // Call getFilters with appropriate parameters based on which field triggered the refresh
    let fieldName = '';
    switch (event.field) {
      case 'studyName':
        fieldName = 'studyName';
        break;
      case 'WhentoCall':
        fieldName = 'whentocall';
        break;
      case 'age':
        fieldName = 'age';
        break;
      case 'gender':
        fieldName = 'gender';
        break;
      case 'status':
        fieldName = 'status';
        break;
    }

    // Trigger filter options refresh
    this.getFilters(fieldName, 'ok');
  }

  /**
   * Handle export from dynamic table
   */
  onDynamicExport(event: ExportEvent): void {
    if (event.type === 'all') {
      this.exportAsXLSX();
    } else {
      this.exportByFilterAsXLSX();
    }
  }

  /**
   * Handle delete from dynamic table
   */
  onDynamicDelete(selectedRows: participantModel[]): void {
    if (!selectedRows || selectedRows.length === 0) {
      return;
    }

    let selectedApplicantIds = selectedRows.map(par => par.participantId);
    this.participantService.deleteParticipants(selectedApplicantIds).subscribe(res => {
      this.clearDynamicTableSelection();
      this.getApplicants();
      alert('Your selection(s) have been deleted');
    });
  }

  /**
   * Handle row selection change from dynamic table
   */
  onDynamicSelectionChange(event: any): void {
    this.selectedApplicants = event?.selectedRows || [];
    this.updateDeleteButtonState();
  }

  private clearDynamicTableSelection(): void {
    this.deferUiUpdate(() => {
      this.selectedApplicants = [];
      if (this.dynamicTable) {
        this.dynamicTable.selectedRows = [];
      }
      this.updateDeleteButtonState();
    });
  }

  /**
   * Helper to disable selection based on permissions
   */
  disableRowSelection = (row: any): boolean => {
    return this.IsDeleteVisible;
  }

  /**
   * Update column filter options in dynamic table
   */
  private updateDynamicColumnFilterOptions(field: string, options: SelectItem[]): void {
    const column = this.dynamicColumns.find(col => col.filterField === field || col.field === field);
    if (column) {
      column.filterOptions = options;
      // Notify dynamic table component if it exists
      if (this.dynamicTable) {
        this.dynamicTable.updateColumnFilterOptions(field, options);
      }
    }
  }

  /**
   * Restore saved filter state to dynamic table's internal filter UI
   */
  private restoreDynamicTableFilters(): void {
    if (!this.dynamicTable) return;

    const storedFilter = this.userPreferencesStore.applicants();
    if (!storedFilter) return;

    // IMPORTANT: Restore filter hierarchy FIRST before setting filters
    // This ensures updateColumnFilterOptions knows which filters were explicitly set
    if (storedFilter.filterHierarchy && storedFilter.filterHierarchy.length > 0) {
      this.dynamicTable['filterHierarchy'] = [...storedFilter.filterHierarchy];
    }

    // Map applicantsFilter fields to dynamic table filter fields
    const filterMapping = {
      'studyName': storedFilter.studyNumber || [],
      'WhentoCall': storedFilter.whentocall || [],
      'age': storedFilter.age || [],
      'gender': storedFilter.gender || [],
      'status': storedFilter.status || [],
      'dob': storedFilter.dob || []
    };

    // Set both checked and selected filters in dynamic table
    Object.keys(filterMapping).forEach(field => {
      const values = filterMapping[field];
      if (values && values.length > 0) {
        this.dynamicTable.checkedFilters[field] = [...values];
        this.dynamicTable.selectedFilters[field] = [...values];
      }
    });

    // Restore search term
    if (storedFilter.searchTerm) {
      this.dynamicTable.searchTerm = storedFilter.searchTerm;
      this.isSearchFilterApplied = true;
      // Apply the search by triggering the search logic
      setTimeout(() => {
        if (this.dynamicTable && this.dynamicTable.searchTerm) {
          this.dynamicTable.applySearchTerm(this.dynamicTable.searchTerm, false);
        }
      }, 50);
    }

    // Restore column sorting enabled states
    if (storedFilter.columnSortingEnabled) {
      this.dynamicTable.columnSortingEnabled = { ...storedFilter.columnSortingEnabled };
    }

    // Restore column filtering enabled states
    if (storedFilter.columnFilteringEnabled) {
      this.dynamicTable.columnFilteringEnabled = { ...storedFilter.columnFilteringEnabled };
    }

    // Initialize any filters that weren't explicitly set with all options selected
    // This will respect the filterHierarchy we just set above
    this.dynamicTable.initializeFiltersWithAllSelected(false);
  }
}
